import {
  HeaderSection,
  BannerSection,
  TransformSection,
  CategorySection,
  MyProgressSection,
  CoursesSection,
  KnowledgeHeroSection,
  PricingSection,
  ExpertsSection,
  LearnAppSection,
  LiveClassesSection,
  FreeCoursesSection,
  AchievementSection,
  ConceptSnapshotsSection,
  StudentFeedbackSection,
  CommunitySection,
  FooterSection,
} from '../../components/home';
import { useEffect, useRef } from 'react';
import { useHomeDashboard } from '../../hooks/useHomeDashboard';
import { useAuthContext } from '../../context/AuthContext';
import { useSubscriptionContext } from '../../context/SubscriptionContext';

function HomePage() {
  const { isLoggedIn } = useAuthContext();
  const { data, loading, error, refetch } = useHomeDashboard();
  const {
    hasActiveSubscription,
    activeCategoryId,
    loading: subscriptionsLoading,
  } = useSubscriptionContext();

  const showMyProgress = isLoggedIn && hasActiveSubscription;
  const showPricing = !subscriptionsLoading && !hasActiveSubscription;
  const wasLoggedInRef = useRef(isLoggedIn);

  useEffect(() => {
    if (isLoggedIn && !wasLoggedInRef.current) {
      refetch();
    }
    wasLoggedInRef.current = isLoggedIn;
  }, [isLoggedIn, refetch]);

  return (
    <>
      <HeaderSection />

      <BannerSection banners={data?.banners} loading={loading} />
      <TransformSection />
      <CategorySection subjects={data?.subjects} loading={loading} error={error} />
      {showMyProgress && <MyProgressSection categoryId={activeCategoryId} />}
      <CoursesSection courses={data?.newLaunchesCourses} loading={loading} />
      <KnowledgeHeroSection />
      {showPricing && (
        <PricingSection plansByCategory={data?.plansByCategory} loading={loading} />
      )}
      <ExpertsSection instructors={data?.instructors} loading={loading} error={error} />
      <LearnAppSection />
      <LiveClassesSection />
      <FreeCoursesSection courses={data?.freeCourses} loading={loading} />
      <AchievementSection />
      <ConceptSnapshotsSection videos={data?.shortVideos} loading={loading} error={error} />
      <StudentFeedbackSection testimonials={data?.testimonials} loading={loading} error={error} />
      <CommunitySection />
      <FooterSection />
    </>
  );
}

export default HomePage;
